import React, { useEffect, useState } from "react";
import { Search, ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Footer from "../layout/Footer";
import Header from "../layout/Header";
import { blogPosts } from "../../utils/blogData";
import { motion } from "framer-motion";
import Meta from "../Meta/Meta";
const BlogPage = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = [
    "All",
    ...Array.from(new Set(blogPosts.map((post) => post.category))),
  ];

  const filteredPosts = blogPosts.filter((post) => {
    const matchesSearch =
      searchTerm === "" ||
      post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.excerpt.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.tags.some((tag) =>
        tag.toLowerCase().includes(searchTerm.toLowerCase()),
      );

    const matchesCategory =
      selectedCategory === "All" || post.category === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  return (
    <div className="min-h-screen bg-gray-50">
      <Meta
        title="MaxiPitch Blog | Sales Automation & Lead Generation Tips"
        description="Read the MaxiPitch blog for tips on sales automation, lead generation, AI marketing, outbound campaigns, and strategies to grow your business faster."
        url="https://maxipitch.com/blog"
      />
      <Header />

      {/* Page Header */}
      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
        className="py-8 bg-gradient-to-r from-indigo-500/5 via-purple-500/5 to-pink-500/5 text-center  max-md:mt-0"
      >
        <h1 className=" bg-gradient-to-r from-gray-900 via-indigo-800 to-purple-800 bg-clip-text text-transparent max-md:mb-2  pb-2">
          MaxiPitch Blog
        </h1>
        <p className="text-xl max-md:text-base text-gray-800 max-w-2xl mx-auto max-md:px-2">
          Explore actionable guides, research-backed tips, and trends in smart
          prospecting, email outreach, and sales growth
        </p>
      </motion.div>

      {/* Search & Filter */}
      {/* <div className="max-w-7xl mx-auto px-4 pt-6 ">
        <div className="flex flex-row gap-4 justify-between">
          <div className="relative w-1/2 md:w-1/2">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search blog posts..."
              className="w-full  pl-10 pr-4 py-2.5 max-md:py-1.5 border rounded-md focus:ring-2 focus:ring-indigo-500 outline-none"
            />
          </div>

          <div className="relative">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center max-md:text-start gap-2 max-md:gap-0 px-4 py-2  max-md:py-1 max-md:px-1.5 border border-indigo-500 rounded-md max-md:text-xs"
            >
              Filter by Category
              <ChevronDown
                className={`transition-transform ${
                  isDropdownOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {isDropdownOpen && (
              <div className="absolute z-50 mt-2 w-full bg-white rounded-lg shadow border">
                {categories.map((category) => (
                  <button
                    key={category}
                    onClick={() => {
                      setSelectedCategory(category);
                      setIsDropdownOpen(false);
                    }}
                    className={`w-full text-left px-4 py-2 hover:bg-gray-100 ${
                      selectedCategory === category
                        ? "bg-indigo-50 text-indigo-600"
                        : ""
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div> */}

      {/* Blog Grid */}
      <div className="max-w-7xl mx-auto px-4 py-10 z-0">
        {filteredPosts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.map((post) => (
              <article
                key={post.id}
                onClick={() => navigate(`/blog/${post.id}`)}
                className="group relative cursor-pointer overflow-hidden rounded-2xl bg-white shadow-lg transition-all duration-500 hover:shadow-2xl hover:-translate-y-2"
              >
                {/* Gradient border effect on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/0 via-purple-500/0 to-pink-500/0  transition-all duration-500 z-0" />

                {/* Image Container with Overlay */}
                <div className="relative h-56 overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent z-10" />
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                  />

                  {/* Category Badge */}
                </div>

                {/* Content */}
                <div className="flex  justify-between  pt-4 px-8">
                  <div className="">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-purple-50 backdrop-blur-sm text-indigo-700 font-medium rounded-full text-xs border border-purple-600">
                      <div className="w-1.5 h-1.5 bg-indigo-500 rounded-full animate-pulse" />
                      {post.category}
                    </span>
                  </div>

                  {/* Read Time Badge */}
                  <div className="">
                    <span className="px-3 py-1.5  backdrop-blur text-gray-800 text-xs rounded-full">
                      {post.readTime}
                    </span>
                  </div>
                </div>

                <div className="relative p-6 z-10 bg-white">
                  {/* Title with Gradient Text on Hover */}
                  <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-indigo-600 group-hover:to-purple-600 group-hover:bg-clip-text transition-all duration-300">
                    {post.title}
                  </h2>

                  {/* Excerpt */}
                  <p className="text-gray-600 text-sm mb-4 line-clamp-2 leading-relaxed">
                    {post.excerpt}
                  </p>

                  {/* Tags */}
                  <div className="flex flex-wrap gap-2 mb-5">
                    {post.tags.slice(0, 2).map((tag, i) => (
                      <span
                        key={i}
                        className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full hover:bg-gray-200 transition-colors"
                      >
                        #{tag}
                      </span>
                    ))}
                    {post.tags.length > 2 && (
                      <span className="px-3 py-1 text-gray-500 text-xs">
                        +{post.tags.length - 2} more
                      </span>
                    )}
                  </div>
                </div>

                {/* Hover Effect Border */}
                <div className="absolute inset-0 border-2 border-transparent group-hover:border-indigo-100 rounded-2xl transition-all duration-500 pointer-events-none" />
              </article>
            ))}
          </div>
        ) : (
          <div className="text-center py-20 bg-white rounded-lg shadow">
            <h3 className="text-xl font-semibold">No articles found</h3>
            <button
              onClick={() => {
                setSearchTerm("");
                setSelectedCategory("All");
              }}
              className="mt-4 text-indigo-600 font-medium"
            >
              Clear filters
            </button>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default BlogPage;
